export default __webpack_public_path__ + "static/media/community2.5e291c33.png";